<template>
  <v-navigation-drawer color="" fixed app :="true" style="margin-top: 1rem">
    <v-list class="py-0">
      <v-list-item  class="px-0" @click="editProfile()">
        <v-list-item-content>
          <v-list-item-title class="title"> Izipark </v-list-item-title>
          <v-list-item-subtitle>
            {{ user.first_name }} {{ user.last_name }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-row justify="center" no-gutters>
          <v-btn color="transparent" rounded depressed @click="logout"
            v-if="this.$store.getters['Authenticate/isLoggedIn']"><v-icon left>fas
              fa-power-off</v-icon>&nbsp;&nbsp;Logout</v-btn>
        </v-row>
      </v-list-item>
      <v-list-item-group :value="selected_menu" class="mt-5">
        <v-list-item class="menu-item" v-for="(item, i) in list" :key="i" link @click="goToRoute(item, i)">
          <v-list-item-icon align="center">
            <div class="icon">
              <img :src="item.icon" alt="" />
            </div>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import route from "@/router/index";
import { mapState } from "vuex";
import SiteFooter from "@/components/layout/footer.vue";

export default {
  created() {
    this.$store.dispatch("Authenticate/me");
  },
  watch: {
    $route: {
      handler(to, from) {
        this.$store.dispatch("Notifications_cms/getListAllNotifications", {
          show_all: "enable",
          is_read: false,
        });
      },
      immediate: true,
    },
  },
  components: { SiteFooter },
  computed: {
    role_name() {
      return this.user && this.user.role ? this.user.role.label : "";
    },
    ...mapState({
      list: (state) => state.Menu.list,
      selected_menu: (state) => state.Menu.selected_menu,
      user: (state) => state.Authenticate.user,
    }),
  },
  methods: {
    goToRoute(item, index) {
      this.selected = index;
      route.push(item.link).catch(() => { });
    },
    editProfile() {
      this.$router.push("/admin/profile");
    },
    logout() {
      this.$store.dispatch("Authenticate/logout");
    },
  },
};
</script>
